PJQ.views.meetings = PJQ.views.meetings ? PJQ.views.meetings : {};
PJQ.views.meetings.MeetingSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'meetings'),
        model: null,
        customFields: null
    },
    events: {

    },
    afterRender: function() {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.onChange(this.model);
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});
